import { render, staticRenderFns } from "./AccordionComponent.vue?vue&type=template&id=0dd82ba2"
import script from "./AccordionComponent.vue?vue&type=script&lang=ts"
export * from "./AccordionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports